import { useState, useEffect } from 'react';
import { useLanguage } from '../services/languageContext';
import { translateText } from '../services/translate';

/**
 * Hook to auto-translate user content (products, CMS blocks) to the current language.
 * Returns the original text immediately, then updates with translation when ready.
 */
export function useTranslatedText(text: string | undefined, sourceLang?: string): string {
  const { lang } = useLanguage();
  const [translated, setTranslated] = useState(text || '');

  useEffect(() => {
    const raw = (text || '').trim();
    if (!raw) {
      setTranslated('');
      return;
    }
    setTranslated(raw); // Показать оригинал сразу при смене текста/языка
    const src = sourceLang || 'ru';
    if (src === lang) return; // Уже на нужном языке
    let cancelled = false;
    translateText(raw, lang, src).then((result) => {
      if (!cancelled) setTranslated(result);
    });
    return () => { cancelled = true; };
  }, [text, lang, sourceLang]);

  return translated || text || '';
}
